import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { withRouter, Switch as RouterSwitch } from 'react-router-dom'
import { Button, Select, Switch, Space, Alert, Tag } from 'antd'
import PageLoader from '../../../components/Layouts/PageLoader'
import PrivateRoute from '../../../hocs/PrivateRoute'
import {
  getRequest,
  patchRequest,
  dutyPaymentConfigUrl,
  successNotification,
  errorNotification
} from '../../../config'

const { Option } = Select

// Read + edit the duty assistant's active payment flow (web LINK vs in-chat mobile money).
// Backed by the w-api DutyPaymentConfig singleton (spec: duty-in-chat-payments).
const PaymentsSettings = () => {
  const [loading, setLoading] = useState(false)
  const [saving, setSaving] = useState(false)
  const [config, setConfig] = useState(null)

  const load = async () => {
    const res = await getRequest(dutyPaymentConfigUrl, 'payment config', setLoading)
    if (res.success) setConfig(res.data)
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line
  }, [])

  const set = (key, value) => setConfig(c => ({ ...c, [key]: value }))

  const handleSave = async () => {
    setSaving(true)
    const res = await patchRequest(
      dutyPaymentConfigUrl,
      {
        activeFlow: config.activeFlow,
        linkEnabled: config.linkEnabled,
        inChatEnabled: config.inChatEnabled
      },
      'payment config',
      () => {}
    )
    setSaving(false)
    if (res.success) {
      setConfig(res.data)
      successNotification('Payment flow updated')
    } else {
      errorNotification('Could not update the payment flow, retry.')
    }
  }

  return (
    <PageLoader className="container" loading={loading}>
      <div className="card mb-5rem">
        <div className="card-body">
          <h3 style={{ marginBottom: 8 }}>Payment Flow</h3>
          <p style={{ color: '#888', marginBottom: 16 }}>
            Choose how customers pay the duty service fee. <b>Web link</b> sends a Pay Now
            link to the website. <b>In-chat mobile money</b> charges MTN/Telecel/AirtelTigo
            inside WhatsApp (card still uses the link). If the selected flow is disabled, the
            other enabled one is used automatically.
          </p>

          {config && (
            <>
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', marginBottom: 4 }}>Active flow</label>
                <Select
                  style={{ width: 320, maxWidth: '100%' }}
                  value={config.activeFlow}
                  onChange={v => set('activeFlow', v)}
                >
                  {(config.choices || []).map(ch => (
                    <Option key={ch.value} value={ch.value}>
                      {ch.label}
                    </Option>
                  ))}
                </Select>
                {config.resolvedFlow && config.resolvedFlow !== config.activeFlow && (
                  <Tag color="orange" style={{ marginLeft: 12 }}>
                    Falling back to {config.resolvedFlow} (selected flow disabled)
                  </Tag>
                )}
              </div>

              <div style={{ marginBottom: 12 }}>
                <Space>
                  <Switch
                    checked={config.linkEnabled}
                    onChange={v => set('linkEnabled', v)}
                  />
                  <span>Web payment link enabled</span>
                </Space>
              </div>
              <div style={{ marginBottom: 20 }}>
                <Space>
                  <Switch
                    checked={config.inChatEnabled}
                    onChange={v => set('inChatEnabled', v)}
                  />
                  <span>In-chat mobile money enabled</span>
                </Space>
              </div>

              {!config.linkEnabled && !config.inChatEnabled && (
                <Alert
                  type="warning"
                  showIcon
                  style={{ marginBottom: 16 }}
                  message="Both flows are disabled"
                  description="The backend will fall back to the web link so payments still work."
                />
              )}

              <Button type="primary" loading={saving} onClick={handleSave}>
                Save
              </Button>
            </>
          )}
        </div>
      </div>
    </PageLoader>
  )
}

const PaymentsRoutes = props => (
  <RouterSwitch>
    <PrivateRoute exact path={props.match.path} component={PaymentsSettings} />
  </RouterSwitch>
)

PaymentsRoutes.propTypes = {
  match: PropTypes.object
}

export default withRouter(PaymentsRoutes)
